import { Button, Container, Divider, FormControl, Grid, IconButton, InputAdornment, TextField, Typography, Tooltip, FormHelperText } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Add, CloudUpload } from "@mui/icons-material";
import * as queryString from "query-string";
import React, { useEffect, useRef, useState } from "react";
import { QrReader } from "react-qr-reader";
import { useHistory, useLocation } from "react-router-dom";
import Autocomplete from "@mui/material/Autocomplete";
import { getFormDataFromFiles, GetValidPlannedDates, qrScroll } from "../../common";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import GenericDatePicker from "../../components/GenericDatePicker/GenericDatePicker";
import { rrulestr } from "rrule";
import { isMobile } from "react-device-detect";
import RecurrencePopup from "../../components/Popup/RecurrencePopup";
import RuleGenerator from "../../components/RuleGenerator/RuleGenerator";
import Shift from "../../components/Dropdowns/Shift";

import moment from "moment";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getPoolList } from "../../store/actions/breakDownTasksActions";
import { getMaintenanceType, getPMGetOrderDetailById, pmCreateOrderAfter, pmUpdateOrderAfter, postPMCreateOrder, postPMUpdateOrder } from "../../store/actions/PMActions";
import { addPlannedFiles } from "../../store/actions/PlannedMaintenanceDetailActions";
import { getUserRoleGroupList } from "../../store/actions/userActions";
import { getEqGetByBarcodeContext } from "../../store/actions/EquipmentAction";
import { getPlannedList } from "../../store/actions/CheckItemGroupActions";
import { convertToPlannedMaintenance, getToBePlannedDetailById } from "../../store/actions/ToBePlannedActions";
import { getShifts } from "../../store/actions/ShiftActions";
import GroupItemListPopup from "../../components/Popup/GroupItemListPopup";
import DatePicker from "react-multi-date-picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import Machine from "../../components/TextFields/Machine/Machine";
import FileUploaderPopup from "../../components/Popup/FileUploaderPopup";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import CropFreeIcon from "@mui/icons-material/CropFree";
import SearchIcon from "@mui/icons-material/Search";

const useStyles = makeStyles((theme) => ({
    button: {
        width: 80,
        height: 80,
        padding: 0,
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    container: {
        display: "flex",
        flexWrap: "wrap",
    },
}));

export default function CreatePlannedMaintenance(props) {
    const classes = useStyles();
    const [pageLoaded, setPageLoaded] = useState(false);
    const [recurrencePopupIsOpen, setRecurrencePopupIsOpen] = useState(false);
    const [recurrence, setRecurrence] = useState([]);
    const [ruleString, setRuleString] = useState("");
    const [ruleText, setRuleText] = useState("");
    const [bdTaskId, setBdTaskId] = useState(null);

    const fromPage = queryString.parse(window.location.search).from;
    const { t } = useTranslation("translation");
    const dispatch = useDispatch();
    const location = useLocation();
    const options = [t("ChooseMaintenanceSchedule"), t("ChooseManualDate")];
    const [chooseDate, setchooseDate] = useState("");
    const [plannedPersons, setPlannedPersons] = useState(0);
    const [plannedHours, setPlannedHours] = useState("0");
    const [toBePlannedId, setToBePlannedId] = useState(undefined);
    let plannedMaintenanceId = undefined;

    const { shiftList } = useSelector(({ Shifts }) => Shifts);

    if (fromPage !== "toBePlanned") {
        plannedMaintenanceId = queryString.parse(window.location.search).id;
    }

    useEffect(() => {
        if (fromPage === "breakdown") {
            setBdTaskId(parseInt(new URLSearchParams(props.location.search).get("bdid")));
            setSelectedPoolCode(parseInt(new URLSearchParams(props.location.search).get("poolid")));
            setSelectedPoolName(new URLSearchParams(props.location.search).get("poolname"));
            SetEquipment(parseInt(new URLSearchParams(props.location.search).get("equipmentid")), new URLSearchParams(props.location.search).get("equipmentname"));
        }
        else if (fromPage === "toBePlanned") {
            setToBePlannedId(queryString.parse(window.location.search).id);
            dispatch(getToBePlannedDetailById(queryString.parse(window.location.search).id));
        }
        else if (fromPage !== "list" && fromPage !== "toBePlanned") {
            setPageLoaded(false);
            SetEquipment(queryString.parse(window.location.search).equipmentId, queryString.parse(window.location.search).equipmentName);
            setMachineStates(initialMachineStates);
            setNotes("");
            setSelectedPoolCode(null);
            setSelectedPoolName(null);
            setRuleText("");
            setRuleString("");
            setSelectedMaintenanceType(null);
            setSelectedMaintenanceTypeName(null);
            setPlannedPersons(0);
            setPlannedHours(0);
            setSelectedShiftType("");
        }
        LoadHandler();
    }, []);

    const LoadHandler = () => {
        loadGroupItemListData(false);
        if (plannedMaintenanceId !== undefined) {
            GetPlannedMaintenanceOrder();
        }
        LoadPoolData();
        LoadMaintenanceTypesData();
        dispatch(getShifts());
    };

    const SetEquipment = (id, name) => {
        if (id != null && name != null) {
            setMachineStates({ ...machineStates, selectedMainEquipmentCode: Number(id), selectedMainEquipmentName: name });
        }
    };

    const { pm } = useSelector((pm) => pm);
    const { equipment } = useSelector((state) => state);
    const { breakDownTask } = useSelector((breakDownTask) => breakDownTask);
    const user = useSelector(({ user }) => user);
    const { ToBePlanned } = useSelector((ToBePlanned) => ToBePlanned);

    useEffect(() => {
        dispatch(getUserRoleGroupList());
        const userRoles = user.userRoleGroupList.resultObject;

        if (pm?.maintenanceType?.errorCode === 0) {
            setMaintenanceTypes(pm?.maintenanceType?.resultObject);
        }
        if (pm?.pmOrderById?.errorCode === 0) {
            let viewModel = pm?.pmOrderById?.resultObject;
            setNotes(viewModel.notes);
            setSelectedPoolCode(parseInt(viewModel.poolId));
            setSelectedPoolName(viewModel.poolName);
            SetEquipment(viewModel.equipmentId, viewModel.equipmentName);
            setRuleText(viewModel.ruleText);
            setRuleString(viewModel.ruleString);
            setSelectedMaintenanceType(viewModel.maintenanceTypeId);
            setSelectedMaintenanceTypeName(viewModel.maintenanceTypeName);
            setPlannedPersons(viewModel.plannedPersonCount);
            setPlannedHours("", viewModel.plannedHoursPerPerson);
            setSelectedShiftType(viewModel.shiftNo);
            viewModel.taskDays && setOperatorDate(viewModel.taskDays[0]);
            pm.pmOrderById = null;

            if (viewModel.ruleText.length > 0) {
                setchooseDate(t("ChooseMaintenanceSchedule"));
            } else {
                setchooseDate(t("ChooseManualDate"));
                let newRules = [];
                viewModel.taskDays.forEach((element) => {
                    newRules.push(moment(element).format("YYYY-MM-DD"));
                });
                setDates(newRules);
            }

            if (location.state?.copy) {
                setRecurrence(GetValidPlannedDates(viewModel.taskDays));
                if (viewModel.ruleText.length > 0) {
                    rrulestr(viewModel.ruleString).origOptions.dtstart = new Date();
                }
            } else {
                setRecurrence(viewModel.taskDays);
            }
            var newSelectedGroupItemIDs = [];
            groupItemListData.forEach((element) => {
                if (viewModel.groupIds?.includes(element.id)) {
                    element.checked = true;
                    newSelectedGroupItemIDs.push(element.id);
                }
            });
            setSelectedGroupItemIDs(newSelectedGroupItemIDs);
        }
        if (pm?.pmCreateOrder?.errorCode === 0) {
            dispatch(pmCreateOrderAfter());
            if (fromPage === "list") {
                history.push({ pathname: "/planned-maintenance-order-list" });
            } else if (fromPage === "calendar") {
                history.push({ pathname: "/planned-maintenance-calendar" });
            } else if (fromPage === "toBePlanned") {
                dispatch(convertToPlannedMaintenance(toBePlannedId));
            } else {
                if (userRoles.some((element) => element.id === 6) && userRoles.some((element) => element.id === 5)) {
                    const currentUrl = new URL(window.location.href);
                    let from = currentUrl.searchParams.get("from") || "technician";
                    if (from === "breakdown") {
                        history.push({ pathname: `/technicianmainpage` });
                    } else {
                        history.push({ pathname: `/${from}mainpage` });
                    }
                }
                //Technician Role
                else if (userRoles.some((element) => element.id === 5)) {
                    history.push({ pathname: "/technicianmainpage" });
                }
                //Operator Role
                else if (userRoles.some((element) => element.id === 6)) {
                    history.push({ pathname: "/operatormainpage" });
                }
            }
        }
        if (pm?.pmUpdateOrder?.errorCode === 0) {
            if (fromPage === "list") {
                history.push({ pathname: "/planned-maintenance-order-list" });
            } else if (fromPage === "calendar") {
                history.push({ pathname: "/planned-maintenance-calendar" });
            }
            dispatch(pmUpdateOrderAfter());
        }
        if (pm?.pmAddFiles?.errorCode === 0) {
            pm.pmAddFiles = [];
        }
    }, [pm]);

    useEffect(() => {
        if (equipment?.eqByBarCode?.resultObject) {
            const result = equipment.eqByBarCode.resultObject;
            // mainEquipment may be an object {id, name} or a string, or null/undefined
            const mainEquipmentName = typeof result?.mainEquipment === "object" && result?.mainEquipment !== null ? result?.mainEquipment?.name : result?.mainEquipment;
            const mainEquipmentId = typeof result?.mainEquipment === "object" && result?.mainEquipment !== null ? result?.mainEquipment?.id : result?.mainEquipmentId;

            if (result?.mainEquipment) {
                // Scanned equipment is a sub-equipment: fill area, main equipment, and sub equipment
                const newMachineStates = {
                    selectedAreaCode: result?.areaId,
                    selectedAreaName: result?.areaName,
                    selectedMainEquipmentCode: mainEquipmentId,
                    selectedMainEquipmentName: mainEquipmentName,
                    selectedSubEquipmentCode: result?.id,
                    selectedSubEquipmentName: result?.name,
                };
                setMachineStates(newMachineStates);
            } else {
                // Scanned equipment is a main equipment: fill only area and main equipment
                const newMachineStates = {
                    selectedAreaCode: result?.areaId,
                    selectedAreaName: result?.areaName,
                    selectedMainEquipmentCode: result?.id,
                    selectedMainEquipmentName: result?.name,
                    selectedSubEquipmentCode: null,
                    selectedSubEquipmentName: null,
                };
                setMachineStates(newMachineStates);
            }
            setQrOpen(false);
            equipment.eqByBarCode.resultObject = null;
        }
    }, [equipment?.eqByBarCode?.resultObject]);

    useEffect(() => {
        if (breakDownTask?.poolList?.errorCode === 0) {
            setPageLoaded(true);
            setPoolData(breakDownTask?.poolList?.resultObject);
        }
    }, [breakDownTask]);

    const { plannedItemGroupList } = useSelector(({ CheckItemGroup }) => CheckItemGroup);
    useEffect(() => {
        if (plannedItemGroupList?.resultObject) {
            plannedItemGroupList.resultObject.forEach((element) => {
                element.checked = false;
            });
            setGroupItemListData(plannedItemGroupList.resultObject);
        }
    }, [plannedItemGroupList]);

    //useeffect to toBePlannedDetailById
    useEffect(() => {
        if (ToBePlanned?.toBePlannedDetailById?.errorCode === 0 && fromPage === "toBePlanned") {
            let detail = ToBePlanned.toBePlannedDetailById.resultObject;
            setPageLoaded(true);
            setNotes(detail.notes);
            setSelectedPoolCode(detail.poolId);
            setSelectedPoolName(detail.poolName);
            SetEquipment(detail.equipmentId, detail.equipmentName);
            setSelectedMaintenanceType(detail.maintenanceTypeId);
            setSelectedMaintenanceTypeName(detail.maintenanceTypeName);
            setPlannedPersons(detail.plannedPersonCount);
            setPlannedHours("", detail.plannedHoursPerPerson);
        }
        if (ToBePlanned?.isTaskUpdated) {
            history.push({ pathname: "/to-be-planned" });
        }
    }, [ToBePlanned]);

    const [maintenanceTypes, setMaintenanceTypes] = useState([]);
    const LoadMaintenanceTypesData = () => {
        dispatch(getMaintenanceType());
    };

    //load pool data
    let [poolData, setPoolData] = useState([]);
    const LoadPoolData = () => {
        dispatch(getPoolList());
    };

    //load shift data
    let [shiftData, setShiftData] = useState([]);
    useEffect(() => {
        if (shiftList?.resultObject?.length > 0) {
            setShiftData(shiftList.resultObject[0].shifts);
        }
    }, [shiftList]);

    // GroupItemList Popup
    const [isGroupItemList, setIsGroupItemList] = useState(false);
    const [groupItemListData, setGroupItemListData] = useState([]);
    const [selectedGroupItemIDs, setSelectedGroupItemIDs] = useState([]);

    const loadGroupItemListData = (includeNonValids) => {
        // parametre false gönderilip sadece valid olan grupları getirir.
        dispatch(getPlannedList(includeNonValids));
    };

    const handleGroupItemListOpen = () => {
        setIsGroupItemList(true);
    };

    const handleGroupItemListConfirm = (newGroupItemListData) => {
        const newSelectedGroupItemIDs = [];
        newGroupItemListData.forEach((groupItem) => {
            if (groupItem.checked) {
                newSelectedGroupItemIDs.push(groupItem.id);
            }
        });

        setGroupItemListData(newGroupItemListData);
        setSelectedGroupItemIDs(newSelectedGroupItemIDs);
        setIsGroupItemList(false);
    };

    const handleGroupItemListCancel = () => {
        setIsGroupItemList(false);
    };

    //request detail
    const [notes, setNotes] = useState("");
    const HandleNotes = (event) => {
        setNotes(event.target.value);
    };

    //set poolCode
    let [selectedPoolCode, setSelectedPoolCode] = useState(null);
    let [selectedPoolName, setSelectedPoolName] = useState(null);
    const HandlePoolChange = (poolId) => {
        if (poolId != null) {
            const filteredPool = poolData.filter((item) => item.name.includes(poolId));
            setSelectedPoolCode(filteredPool[0].id);
            setSelectedPoolName(filteredPool[0].name);
            return filteredPool[0].id;
        } else {
            setSelectedPoolCode(0);
            setSelectedPoolName("");
        }
    };

    const [selectedMaintenanceType, setSelectedMaintenanceType] = useState(null);
    const [selectedMaintenanceTypeName, setSelectedMaintenanceTypeName] = useState(null);
    const HandleMaintenanceTypeChange = (maintenanceId) => {
        if (maintenanceId != null) {
            const filteredType = maintenanceTypes.filter((item) => item.name.includes(maintenanceId));
            setSelectedMaintenanceType(filteredType[0].id);
            setSelectedMaintenanceTypeName(filteredType[0].name);
            return filteredType[0].id;
        } else {
            setSelectedMaintenanceType(0);
            setSelectedMaintenanceTypeName("");
        }
    };

    const [selectedShiftNo, setSelectedShiftNo] = useState("");
    const [selectedShiftType, setSelectedShiftType] = useState("");
    const HandleShift = (shiftNo) => {
        if (shiftNo != null) {
            const filteredType = shiftData.filter((item) => item.shiftNo == shiftNo);
            setSelectedShiftNo(filteredType[0].id);
            setSelectedShiftType(filteredType[0].shiftNo.toString());
            return filteredType[0].id;
        } else {
            setSelectedShiftNo(0);
            setSelectedShiftType("");
        }
    };

    const GetPlannedMaintenanceOrder = () => {
        dispatch(getPMGetOrderDetailById({ id: plannedMaintenanceId, showDates: false }));
    };

    const getDateHandler = () => {
        if (chooseDate === t("ChooseMaintenanceSchedule")) {
            return recurrence;
        } else {
            setRuleString("");
            setRuleText("");
            return dates;
        }
    };

    //submit request
    const history = useHistory();
    const AddOrderHandler = () => {
        let operatorDates = [];
        let date = moment(operatorDate).format("YYYY-MM-DD");
        operatorDates.push(date);
        const data = {
            notes: notes,
            equipmentId: machineStates.selectedSubEquipmentCode ?? machineStates.selectedMainEquipmentCode ?? 0,
            poolId: selectedPoolCode || 0,
            taskDays: fromPage === "operator" || fromPage === "breakdown" ? operatorDates : isMobile === true ? operatorDates : getDateHandler(),
            ruleString: !location.state?.copy ? ruleString : "", // task kopyalamadan geliyorsa ve tarih tipi değiştirildiyse boş değer gönderilmeli.
            ruleText: !location.state?.copy ? ruleText : "", // task kopyalamadan geliyorsa ve tarih tipi değiştirildiyse boş değer gönderilmeli.
            maintenanceTypeId: selectedMaintenanceType || 0,
            UnplannedMaintenanceOrderTaskId: bdTaskId,
            groupIds: selectedGroupItemIDs,
            plannedPersonCount: plannedPersons || 0,
            plannedHoursPerPerson: parseFloat(plannedHours) || 0,
            shiftNo: parseInt(selectedShiftType) || 1, //vardiya seçilmemişse otomatik 1.vardiyaya atansın.
        };

        data.taskDays = data.taskDays.map((item) => new Date(item).getFullYear() + "/" + ("0" + (new Date(item).getMonth() + 1)).slice(-2) + "/" + new Date(item).getDate());
        formData.append("plannedOrder", JSON.stringify(data));
        dispatch(postPMCreateOrder(formData));
    };

    const UpdateOrderHandler = () => {
        const data = {
            id: parseInt(plannedMaintenanceId),
            notes: notes,
            equipmentId: machineStates.selectedSubEquipmentCode ?? machineStates.selectedMainEquipmentCode ?? 0,
            poolId: selectedPoolCode || 0,
            taskDays: getDateHandler(),
            ruleString: chooseDate === t("ChooseMaintenanceSchedule") ? ruleString : "",
            maintenanceTypeId: selectedMaintenanceType || 0,
            ruleText: chooseDate === t("ChooseMaintenanceSchedule") ? ruleText : "",
            groupIds: selectedGroupItemIDs,
            plannedPersonCount: plannedPersons || 0,
            plannedHoursPerPerson: parseFloat(plannedHours) || 0,
            shiftNo: parseInt(selectedShiftType),
        };
        dispatch(postPMUpdateOrder(data));
    };

    // Machine popup
    const initialMachineStates = {
        selectedAreaCode: null,
        selectedAreaName: null,
        selectedMainEquipmentCode: null,
        selectedMainEquipmentName: null,
        selectedSubEquipmentCode: null,
        selectedSubEquipmentName: null,
    };
    const [machineStates, setMachineStates] = useState(initialMachineStates);

    //QR Code
    let [qrOpen, setQrOpen] = useState(false);
    const [state, setState] = useState({
        qrResult: "No result",
    });

    const qrRef = useRef();
    let executedScroll = false;
    const HandleScan = (data) => {
        executedScroll = qrScroll(qrRef, executedScroll);
        if (data) {
            setState({ ...state, qrResult: data });
            dispatch(getEqGetByBarcodeContext(data));
        }
    };

    const OnRecurrenceSelected = (rules, ruleString, ruleText) => {
        setRecurrence(rules);
        setRuleString(ruleString);
        setRuleText(ruleText);
        setRecurrencePopupIsOpen(false);
    };

    const [plannedFiles, setPlannedFiles] = useState([]);
    const [formData, setFormData] = useState(new FormData());
    const [isFileUploaderPopupOpen, setIsFileUploaderPopupOpen] = useState(false);
    const UploadFiles = (files) => {
        const newFormData = getFormDataFromFiles(files);
        if (plannedMaintenanceId !== undefined) {
            const payload = {
                plannedId: plannedMaintenanceId,
                data: newFormData,
            };
            dispatch(addPlannedFiles(payload));
        } else {
            setFormData(newFormData);
            setPlannedFiles(files);
        }
        setIsFileUploaderPopupOpen(false);
    };

    const [operatorDate, setOperatorDate] = useState(fromPage === "operator" || fromPage === "breakdown" ? new Date() : null);
    const OnOperatorDateChangeHandler = (date) => {
        setOperatorDate(date);
    };

    const [dates, setDates] = useState([new Date()]);
    const DateHandler = (date) => {
        let newRules = [];
        date.forEach((element) => {
            newRules.push(element.format());
        });
        setDates(newRules);
    };

    // Validation
    const [error, setError] = useState({
        machineText: t("SelectAMachine"),
        maintenanceTypeText: t("SelectAMaintenanceType"),
    });
    const [isDisable, setIsDisable] = useState(true);

    useEffect(() => {
        if (selectedMaintenanceType) {
            setError({ ...error, maintenanceTypeText: "" });
        } else {
            setError({ ...error, maintenanceTypeText: t("SelectAMaintenanceType") });
        }
    }, [selectedMaintenanceType, recurrence, chooseDate]);

    useEffect(() => {
        if (
            error.maintenanceTypeText === "" &&
            (machineStates.selectedSubEquipmentCode || machineStates.selectedMainEquipmentCode) &&
            (chooseDate === t("ChooseManualDate") || recurrence?.length > 0 || operatorDate != null)
        ) {
            setIsDisable(false);
        } else {
            setIsDisable(true);
        }
    }, [error]);

    let [barcodeOpen, setBarcodeOpen] = useState(false);
    const OpenBarcodeScanner = () => {
        if (barcodeOpen) {
            return (
                <div>
                    <TextField
                        autoFocus
                        onChange={(e) => HandleScanBarcode(e)}
                        onKeyDown={handleKeypress}
                        style={{ width: "100%", marginBottom: 10, marginTop: 20 }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton edge="end" color="primary" onClick={handleSubmit}>
                                        <SearchIcon />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                </div>
            );
        } else {
            return null;
        }
    };

    const HandleScanBarcode = (event) => {
        if (event.target.value) {
            setState({ ...state, result: event.target.value });
        }
    };

    const handleKeypress = (e) => {
        //it triggers by pressing the enter key
        if (e.keyCode === 13) {
            setBarcodeOpen(false);
            dispatch(getEqGetByBarcodeContext(e.target.value));
        }
    };

    const handleSubmit = () => {
        setBarcodeOpen(false);
        dispatch(getEqGetByBarcodeContext(state.result));
    };

    const handlePlannedHours = (e) => {
        let input = e.target.value.replace(",", ".");

        if (input.length > 1 && input[0] === "0" && input[1] !== ".") {
            input = input.slice(1);
        }
        if (/^\d*\.?\d*$/.test(input)) {
            setPlannedHours(input);
        }
    }

    return (
        <div>
            {pageLoaded === true ? (
                <Container id="cpm_Container" fixed maxWidth="xs" style={{ marginTop: 20 }}>
                    <Grid id="cpm_Grid" container justifyContent="center" style={{ marginTop: 30 }}>
                        <Grid id="rb_grid_1" item xs={12}>
                            <IconButton id="rb_iconQrBtn" onClick={() => setQrOpen(true)}>
                                <QrCode2Icon id="rb_centerFcs" className={classes.button} color="primary" />
                            </IconButton>
                            <IconButton id="rb_iconQrBtn" onClick={() => setBarcodeOpen(true)}>
                                <CropFreeIcon id="rb_centerFcs" className={classes.button} color="primary" />
                            </IconButton>
                        </Grid>
                        <Divider id="rb_divider" variant="middle" sx={{ width: "70%", marginTop: "10px" }} />
                        <Grid id="rb_grid_1" item xs={12}>
                            <TextField
                                id="ctbp_TextField_1"
                                multiline
                                maxRows={4}
                                defaultValue={t("ScanQRCodeOrChooseMachine")}
                                InputProps={{ readOnly: true }}
                                variant="outlined"
                                sx={{ width: "80%", marginTop: "10px" }}
                            />
                        </Grid>

                        <Grid id="cpm_Grid_2" item xs={12}>
                            {qrOpen === true ? (
                                <div ref={qrRef}>
                                    <QrReader id="cpm_QrReader" scanDelay={500} onResult={HandleScan} constraints={{ facingMode: "environment" }} style={{ width: "100%", marginBottom: 10 }} />
                                </div>
                            ) : null}
                        </Grid>
                        {OpenBarcodeScanner()}

                        <Grid id="cpm_Grid_4" item xs={12} style={{ marginTop: 20 }}>
                            <FormControl id="cpm_FormControl" variant="outlined" style={{ width: "90%" }}>
                                <Machine setMachineStates={setMachineStates} machineStates={machineStates} isAreaNotFiltered={true} size="normal" error={error} setError={setError} />
                            </FormControl>
                        </Grid>
                        <Grid id="cpm_Grid_5" item xs={12} style={{ marginTop: 20 }}>
                            <FormControl id="cpm_FormControl_1" variant="outlined" style={{ width: "90%" }}>
                                <Autocomplete
                                    id="cpm_Pool_Autocomplete"
                                    value={selectedPoolName}
                                    style={{ marginTop: -15 }}
                                    onChange={(event, newValue) => {
                                        HandlePoolChange(newValue);
                                    }}
                                    options={poolData.map((option) => option.name)}
                                    renderInput={(params) => <TextField id="cpm_TextField_3" {...params} margin="normal" label={t("Pool")} variant="outlined" />}
                                />
                            </FormControl>
                        </Grid>

                        <Grid id="cpm_Grid_6" item xs={12} style={{ marginTop: 20 }}>
                            <FormControl id="cpm_FormControl_2" variant="outlined" style={{ width: "90%" }}>
                                <Autocomplete
                                    id="cpm_MaintenanceType_Autocomplete"
                                    value={selectedMaintenanceTypeName}
                                    defaultValue={""}
                                    style={{ marginTop: -25 }}
                                    onChange={(event, newValue) => {
                                        HandleMaintenanceTypeChange(newValue);
                                    }}
                                    options={maintenanceTypes.map((option) => option.name)}
                                    renderInput={(params) => (
                                        <TextField
                                            id="cpm_TextField_4"
                                            {...params}
                                            margin="normal"
                                            label={t("MaintenanceType")}
                                            variant="outlined"
                                            error={error.maintenanceTypeText.length > 0}
                                            helperText={error.maintenanceTypeText}
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>

                        <Grid id="cpm_Grid_13" item xs={12} style={{ marginTop: 20 }}>
                            <FormControl id="shift_formControl" variant="outlined" style={{ width: "90%" }}>
                                <Shift selectedShiftType={selectedShiftType} HandleShift={HandleShift} shiftData={shiftData} />
                            </FormControl>
                        </Grid>

                        {fromPage !== "operator" && fromPage !== "breakdown" ? (
                            <Grid id="cpm_Grid_11" item xs={12} style={{ marginTop: 20 }}>
                                <FormControl id="cpm_FormControl_3" variant="outlined" style={{ width: "90%" }}>
                                    <Autocomplete
                                        id="cpm_MaintenanceType_Autocomplete_2"
                                        value={chooseDate}
                                        defaultValue={""}
                                        style={{ marginTop: -25 }}
                                        onChange={(event, newValue) => {
                                            setchooseDate(newValue);
                                        }}
                                        options={options}
                                        renderInput={(params) => <TextField id="cpm_TextField_4" {...params} margin="normal" label={t("DateType")} variant="outlined" />}
                                    />
                                </FormControl>
                            </Grid>
                        ) : null}
                        {fromPage !== "operator" && !isMobile && fromPage !== "breakdown" ? (
                            <Grid id="cpm_Grid_7" item xs={12} style={{ marginTop: 20 }}>
                                {chooseDate !== t("ChooseManualDate") ? (
                                    <Grid id="cpm_Grid_8" item xs={12}>
                                        <Button id="cpm_b" style={{ marginBottom: 5, marginRight: 20 }} onClick={() => setRecurrencePopupIsOpen(true)} variant="contained" color="secondary">
                                            {t("ChooseMaintenanceSchedule")}
                                        </Button>
                                        <FormHelperText
                                            id="cam_FormHelperText"
                                            data-tip
                                            data-for="datesInfoText"
                                            style={{
                                                textAlign: "center",
                                                width: "150px",
                                                marginLeft: "115px",
                                                color: recurrence && recurrence.length === 0 ? "red" : "#888",
                                            }}
                                        >
                                            {recurrence && recurrence.length > 0 ? `${recurrence.length}  ${t("DateSelected")}` : t("MaintenanceScheduleNotSelected")}
                                        </FormHelperText>
                                    </Grid>
                                ) : (
                                    <Grid id="cpm_Grid_7" item xs={12}>
                                        <Grid id="cam_Grid_8">
                                            <FormControl variant="outlined" style={{ textAlign: "center" }}>
                                                <DatePicker
                                                    value={dates}
                                                    onChange={DateHandler}
                                                    minDate={new Date()}
                                                    format="YYYY-MM-DD"
                                                    calendarPosition="bottom-center"
                                                    style={{ height: "40px", width: "100%" }}
                                                    multiple
                                                    sort
                                                    plugins={[<DatePanel />]}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                )}
                                <Grid id="cam_Grid_9" item xs={12}>
                                    <Tooltip id="cpm_Tooltip_1" title={t("UploadFile")}>
                                        <IconButton id="cpm_IconButton_3" onClick={() => setIsFileUploaderPopupOpen(true)} size="large">
                                            <CloudUpload id="cpm_CloudUpload" sx={{ width: 50, height: 50, padding: 0 }} style={{ fill: "#757575" }} />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip id="cpm_Tooltip_2" title={t("SelectInstruction")}>
                                        <IconButton id="cpm_IconButton_4" onClick={handleGroupItemListOpen} size="large">
                                            <Add id="cpm_Add" sx={{ width: 50, height: 50, padding: 0 }} style={{ fill: "#757575" }} />
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                            </Grid>
                        ) : (
                            <Grid id="cpm_Grid_8" item xs={12} style={{ marginTop: 20 }}>
                                <GenericDatePicker id="cpm_dp" minMsg={t("AheadOfStartTime")} dateValue={operatorDate} onDateChange={OnOperatorDateChangeHandler} label={t("StartDate")} />
                            </Grid>
                        )}

                        <Grid id="cpm_Grid_9" item xs={12} style={{ marginTop: 20 }}>
                            <TextField
                                id="cpm_TextField_4"
                                style={{ width: "90%" }}
                                multiline
                                label={t("MaintenanceNote")}
                                variant="outlined"
                                onChange={HandleNotes}
                                value={notes}
                                inputProps={{ maxLength: 550 }}
                                helperText={notes.length == 550 ? t("MaxCharacter") : null}
                            />
                        </Grid>

                        <Grid id="cpm_Grid_9" item xs={12} style={{ marginTop: 20 }}>
                            <FormControl variant="outlined" className={classes.formControl} style={{ width: "43%" }}>
                                <TextField
                                    id="cpm_Person"
                                    type="number"
                                    onChange={(e) => setPlannedPersons((v) => (e.target.validity.valid ? e.target.value : v))}
                                    value={plannedPersons}
                                    onInput={(e) => {
                                        e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 4);
                                    }}
                                    InputProps={{
                                        inputProps: { min: 1 },
                                        endAdornment: <InputAdornment position="end">{t("Person")}</InputAdornment>,
                                    }}
                                    variant="outlined"
                                />
                            </FormControl>
                            <FormControl variant="outlined" className={classes.formControl} style={{ width: "43%" }}>
                                <TextField
                                    id="cpm_PersonHour"
                                    type="number"
                                    value={plannedHours}
                                    onChange={(e) => handlePlannedHours(e)}
                                    inputProps={{
                                        min: 0,
                                    }}
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">{t("Person/Hour")}</InputAdornment>,
                                    }}
                                    variant="outlined"
                                />
                            </FormControl>
                        </Grid>

                        <Grid id="cpm_Grid_10" item xs={12} style={{ marginTop: 20 }}>
                            {(fromPage === "list" || fromPage === "calendar" || fromPage === "toBePlanned") && plannedMaintenanceId !== undefined ? (
                                <Grid id="cpm_Grid_11" item xs={12}>
                                    {!location.state?.copy ? (
                                        <Button id="cpm_b_1" style={{ marginBottom: 20 }} onClick={() => UpdateOrderHandler()} variant="contained" color="primary" disabled={isDisable}>
                                            {t("Save")}
                                        </Button>
                                    ) : (
                                        <Button
                                            id="cpm_b_2"
                                            style={{ marginBottom: 20, backgroundColor: "#00897B" }}
                                            onClick={() => AddOrderHandler()}
                                            variant="contained"
                                            color="primary"
                                            disabled={isDisable}
                                        >
                                            {t("CreateNewMaintenance")}
                                        </Button>
                                    )}
                                </Grid>
                            ) : (
                                <Button id="cpm_b_2" style={{ marginBottom: 20 }} onClick={() => AddOrderHandler()} variant="contained" color="primary" disabled={isDisable}>
                                    {t("Save")}
                                </Button>
                            )}
                        </Grid>
                    </Grid>
                </Container>
            ) : null}

            {isGroupItemList ? <GroupItemListPopup open={isGroupItemList} onConfirm={handleGroupItemListConfirm} onCancel={handleGroupItemListCancel} groupItemListData={groupItemListData} /> : null}

            <RecurrencePopup id="cpm_rp" title={t("ChooseMaintenanceSchedule")} open={recurrencePopupIsOpen} onClose={() => setRecurrencePopupIsOpen(false)}>
                <RuleGenerator id="cpm_rg" onSubmit={OnRecurrenceSelected} rule={ruleString !== "" ? rrulestr(ruleString).origOptions : null} ruleString={ruleString} />
            </RecurrencePopup>

            {isFileUploaderPopupOpen ? <FileUploaderPopup isOpen={isFileUploaderPopupOpen} files={plannedFiles} onCancel={() => setIsFileUploaderPopupOpen(false)} onConfirm={UploadFiles} /> : null}

            <LoadingBackdrop id="cpm_lbd" />
        </div>
    );
}